'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;
    //set up user settings inside the page scope
    let pathname = String(window.location.pathname).replace('/', '');
    if (typeof $scope.global.user.settings_local[pathname] === 'undefined') {
        $scope.global.user.settings_local[pathname] = {};
    }

    // make local scope instances of the user objects
    $scope.settings = $scope.global.user.settings_local[pathname];

    model.tableIdentifiers = {
        key: false,
        id: false
    };

    socketIo('/api/general_network/top_ja3').then(function(socket) {
        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            updateTable: '/api/general_network/top_ja3/updateTable',
            hideToggleBytes: true,
            grouping: ['id'],
            sort: {
                direction: '-',
                col: 'count'
            }, // '-'=desc, '+'=asc
            title: 'TOP JA3 hashes',
            columns: [{
                title: 'JA3',
                select: 'ja3',
                dView: true
            }, {
                title: 'Count',
                select: 'count',
                dView: true
            },
            ],
            searchCategories: {
                'ja3': 'JA3',
            }
        })
        // fetch the data when the object is registered
        .then(function(result) {
            model.tableIdentifiers = {
                    id: result.id,
                    key: result.key
                }
                // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);

            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
                // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function(result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function(err) {

        }, function(result) {
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function(err) {
                    console.log('error')
                    console.log(err)
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })

}

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;




/** WEBPACK FOOTER **
 ** ./src/pages/controllers/general_network/top_ja3.js
 **/